import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { export_csv_delimiter } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformCsvDelimiter() {
    const { t } = useTranslation('settings');

    const options = export_csv_delimiter(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'export_csv_delimiter'}
            control={control}
            name={'export_csv_delimiter'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.export_csv_delimiter')}
                        error={errors.export_csv_delimiter?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
